import { Box, Pagination, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import LeadersSearchHeader from "../Leads/LeadersSearchHeader";
import FinalChoicesSummery from "./FinalChoice/FinalChoicesSummery";
import FinalChoicesList from "./FinalChoice/FinalChoicesList";
import { SubmitButton } from "../customComponent/Buttons";
import InputField, { SelectInputField } from "../customComponent/InputField";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllFinalSummaryAction,
  getFinalSummaryByFilterAction
} from "../../actions/reportActions/reportsActions";
import { findAllLeadApplicationAction } from "../../actions/aplicationActions/applicationsAction";
import axios from "axios";

function ReportsTab() {
  const dispatch = useDispatch();

  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);

  const [reportData, setReportData] = useState([]);
  const [name, setName] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [searchValue, setSearchValue] = useState('');
  const [dataCount, setDataCount] = useState(0)

  let { applicationAllFindSuccess } = useSelector((state) => {
    return state.findAllLeadApplication;
  });

  let { paidPaymentStatusSuccess } = useSelector((state) => {
    return state.paidPaymentUpdation;
  });

  useEffect(() => {
    dispatch(findAllLeadApplicationAction(25, page, "Enrolled"));
  }, [dispatch, page, paidPaymentStatusSuccess]);
  
  useEffect(() => {
    if (applicationAllFindSuccess) {
      setDataCount(applicationAllFindSuccess?.totalPages)
      setData(
        applicationAllFindSuccess?.data?.map((item) =>
          createData(
            item.id,
            item?.applicationId,
            item.lead?.firstName,
            item?.universityName,
            item?.courseName,
            // "15 / 02 / 2023",
            item?.createdAt?.split("T")[0],
            item?.isInvoiceCompleted,
            item?.isPaidToGsl,
            item?.isPaidToPartner,
            item?.isNoCommission,
            item?.isCommissionOnGross,
            item?.isCommissionOnNet,
            item?.paidFeeCommission,
            item?.paidFeeCommissionAmt,
            "15 / 02 / 2023"
          )
        )
      );

      setReportData(
        applicationAllFindSuccess?.data?.map((item) =>
          createData(
            item.id,
            item?.applicationId,
            item.lead?.firstName,
            item?.universityName,
            item?.courseName,
            // "15 / 02 / 2023",
            item?.createdAt?.split("T")[0],
            item?.isInvoiceCompleted,
            item?.isPaidToGsl,
            item?.isPaidToPartner,
            item?.isNoCommission,
            item?.isCommissionOnGross,
            item?.isCommissionOnNet,
            item?.paidFeeCommission,
            item?.paidFeeCommissionAmt,
            "15 / 02 / 2023"
          )
        )
      );

      // applicationAllFindSuccess?.data?.map(
      //   (item) => {
      //     // id: item.id,
      //     // universityName: item?.universityName,
      //     // studentName: item.lead?.firstName,
      //     // university: item?.universityCountry,
      //     // course: item?.courseName,
      //     // date: item.intakeDate,
      //     // status: item.methodStatus,
      //   },
      //   [applicationAllFindSuccess]
      // );

      // setApplicationData(
      //   applicationAllFindSuccess?.data?.map((item) => ({
      //     id: item.id,
      //     column1: item.lead?.firstName,
      //     column2: item?.universityCountry,
      //     column3: item?.courseName,
      //     column4: item?.user !== null ? item?.user?.firstName : "Not Assigned",
      //     column5: item.intakeDate,
      //     column6: item.methodStatus,
      //     leadId: item.leadId,
      //   }))
      // );
    }
  }, [applicationAllFindSuccess, page]);

  function createData(
    id,
    applicationId,
    name,
    university,
    course,
    startDate,
    invoice,
    paidToGsl,
    paidToPartner,
    NoCommission,
    CommissionOnGross,
    CommissionOnNet,
    paidFeeCommission,
    paidFeeCommissionAmt,
    paymentDate
  ) {
    return {
      id,
      applicationId,
      name,
      university,
      course,
      startDate,
      // tutionFee,
      invoice,
      paidToGsl,
      paidToPartner,
      NoCommission,
      CommissionOnGross,
      CommissionOnNet,
      paidFeeCommission,
      paidFeeCommissionAmt,
      paymentDate
    };
  }

  const [columnName, setColumnName] = useState(false);
  const [showStudentNameColumn, setShowStudentNameColumn] = useState(false);
  const [showStudentIdColumn, setShowStudentIdColumn] = useState(false);
  const [showStudentUniversityColumn, setShowStudentUniversityColumn] =
    useState(false);
  const [showStudentCourseColumn, setShowStudentCourseColumn] = useState(false);
  const [showStartDateColumn, setShowStartDateColumn] = useState(false);
  const [showTutionFeeColumn, setShowTutionFeeColumn] = useState(false);
  const [showInvoiceColumn, setShowInvoiceColumn] = useState(false);
  const [showPaidToGslColumn, setShowPaidToGslColumn] = useState(false);
  const [showPaidToPartnerColumn, setShowPaidToPartnerColumn] = useState(false);
  const [showPaymentDateColumn, setShowPaymentDateColumn] = useState(false);
  const [finalSummaryData, setFinalSummaryData] = useState({});

  const { finalSummaryCountsSuccess } = useSelector((state) => {
    return state.getAllFinalSummary;
  });

  const columns = [
    {
      title: "Student id",
      field: "studentId",
      hidden: showStudentIdColumn
    },
    {
      title: "Student name",
      field: "studentName",
      hidden: showStudentNameColumn
    },
    {
      title: "university",
      field: "university",
      hidden: showStudentUniversityColumn
    },
    {
      title: "course",
      field: "course",
      hidden: showStudentCourseColumn
    },
    {
      title: "start Date",
      field: "startDate",
      hidden: showStartDateColumn
    },
    // {
    //   title: "Tution Fee",
    //   field: "tutionFee",
    //   hidden: showTutionFeeColumn,
    // },
    {
      title: "invoice",
      field: "invoice",
      hidden: showInvoiceColumn
    },
    {
      title: "No Comm.",
      field: "noComm",
      hidden: showInvoiceColumn
    },
    {
      title: "Comm. on Gross",
      field: "commOnGross",
      hidden: showInvoiceColumn
    },
    {
      title: "Comm. on Net",
      field: "commOnNet",
      hidden: showInvoiceColumn
    },
    {
      title: "Paid Fee Comm.",
      field: "paidFeeComm",
      hidden: showInvoiceColumn
    },
    {
      title: "Paid Comm. Amt ",
      field: "paidFeeCommAmt",
      hidden: showInvoiceColumn
    },
    {
      title: "paid to gsl",
      field: "paidToGsl",
      hidden: showPaidToGslColumn
    },

    {
      title: "paid to partner",
      field: "paidToPartner",
      hidden: showPaidToPartnerColumn
    },
    {
      title: "payment Date",
      field: "paymentDate",
      hidden: showPaymentDateColumn
    }
  ];

  useEffect(() => {
    if (finalSummaryCountsSuccess) {
      setFinalSummaryData(finalSummaryCountsSuccess);
    }
  }, [finalSummaryCountsSuccess]);

  useEffect(() => {
    dispatch(getAllFinalSummaryAction());
  }, [dispatch]);

  const toggleNameColumn = (status, column) => {
    console.log(status, column);
    if (column === "studentName") {
      setColumnName(column);
      setShowStudentNameColumn(status);
    }
    if (column === "studentId") {
      setColumnName(column);
      setShowStudentIdColumn(status);
    }
    if (column === "university") {
      setColumnName(column);
      setShowStudentUniversityColumn(status);
    }
    if (column === "course") {
      setColumnName(column);
      setShowStudentCourseColumn(status);
    }
    if (column === "startDate") {
      setColumnName(column);
      setShowStartDateColumn(status);
    }

    // if (column === "tutionFee") {
    //   setColumnName(column);
    //   setShowTutionFeeColumn(status);
    // }

    if (column === "invoice") {
      setColumnName(column);
      setShowInvoiceColumn(status);
    }
    if (column === "paidToGsl") {
      setColumnName(column);
      setShowPaidToGslColumn(status);
    }
    if (column === "paidToPartner") {
      setColumnName(column);
      setShowPaidToPartnerColumn(status);
    }
    if (column === "paymentDate") {
      setColumnName(column);
      setShowPaymentDateColumn(status);
    }
  };

  const handleFilterResetData = (status) => {
    setName("");
  };

  const applyFilters = () => {
    const filteredData = data.filter((dataItem) => {
      const matchesLocation = dataItem.name
        .toLowerCase()
        .includes(name.toLowerCase());
      return matchesLocation;
    });
    setReportData(filteredData);
  };

  const LeadFilterFunction = (data) => {
    setName(data);
  };

  useEffect(() => {
    applyFilters();
  }, [name]);

  const visibility = [
    {
      label: "Student id",
      name: "studentId",
      status: showStudentIdColumn
    },
    {
      label: "Student name",
      name: "studentName",
      status: showStudentNameColumn
    },
    {
      label: "university",
      name: "university",
      status: showStudentUniversityColumn
    },
    {
      label: "course",
      name: "course",
      status: showStudentCourseColumn
    },
    {
      label: "start Date",
      name: "startDate",
      status: showStartDateColumn
    },
    {
      label: "Tution Fee",
      name: "tutionFee",
      status: showTutionFeeColumn
    },
    {
      label: "invoice",
      name: "invoice",
      status: showInvoiceColumn
    },
    {
      label: "paid to gsl",
      name: "paidToGsl",
      status: showPaidToGslColumn
    },
    {
      label: "paid to partner",
      name: "paidToPartner",
      status: showPaidToPartnerColumn
    },
    {
      label: "payment Date",
      name: "paymentDate",
      status: showPaymentDateColumn
    }
  ];

  const finalSummaryShowClickHandler = () => {
    dispatch(getAllFinalSummaryAction(year, month));
  };

  const handleSearchChange = (e) => {
    try {
      const newSearchValue = e.target.value.trim();
      setSearchValue(newSearchValue);

      if (newSearchValue === "") {
        setReportData(
          applicationAllFindSuccess?.data?.map((item) =>
            createData(
              item.id,
              item?.applicationId,
              item.lead?.firstName,
              item?.universityName,
              item?.courseName,
              // "15 / 02 / 2023",
              item?.createdAt?.split("T")[0],
              item?.isInvoiceCompleted,
              item?.isPaidToGsl,
              item?.isPaidToPartner,
              item?.isNoCommission,
              item?.isCommissionOnGross,
              item?.isCommissionOnNet,
              item?.paidFeeCommission,
              item?.paidFeeCommissionAmt,
              "15 / 02 / 2023"
            )
          )
        );
        return;
      }
    } catch(error) {
      console.error(error);
    }
  }

  const searchHandleChange = async (e) => {
    try {

      const newValue = e.target.value.trim()

      const tabSection = "Enrolled"

      if (newValue === "") {
        dispatch(findAllLeadApplicationAction(25, page, tabSection));
        return
      }

      let isUserExist = localStorage.getItem("loginInfo")
      ? JSON.parse(localStorage.getItem("loginInfo"))
      : null;

    const config = {
      headers: {
        Authorization: `Bearer ${isUserExist?.token}`,
      },
    };

    let UserId = isUserExist?.UserId;

    let { data } = await axios.get(
      `/api/admin/application/findAllApplicationSearch?q=${newValue}&id=${UserId}&limit=${25}&pageCount=${page}&tabSection=${tabSection}`,
      config
    )

    setDataCount(data?.totalPages)

    setReportData(
      data?.data?.map((item) =>
        createData(
          item.id,
          item?.applicationId,
          item?.leadFirstName,
          item?.universityName,
          item?.courseName,
          item?.createdAt?.split("T")[0],
          item?.isInvoiceCompleted,
          item?.isPaidToGsl,
          item?.isPaidToPartner,
          item?.isNoCommission,
          item?.isCommissionOnGross,
          item?.isCommissionOnNet,
          item?.paidFeeCommission,
          item?.paidFeeCommissionAmt,
          "15 / 02 / 2023"
        )
      )
    );

    } catch(error) {
      console.error(error)
    }
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  } 

  return (
    <Box>
      <Box
        sx={{
          background: "#F4F4F4",
          padding: "12px"
        }}
      >
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              sm: "repeat(2,1fr)"
            },
            gap: "20px",
            justifyContent: "space-between",
            alignItems: "center"
          }}
        >
          <SelectInputField
            label="Year"
            handleSelectChange={(e) => setYear(e.target.value)}
            value={year}
            mapMethod=""
            mapValue={[2020, 2021, 2022, 2023, 2024, 2025]}
          />
          <SelectInputField
            label="Month"
            handleSelectChange={(e) => setMonth(e.target.value)}
            value={month}
            mapMethod=""
            mapValue={[
              "All Months",
              "January",
              "February",
              "March",
              "April",
              "May",
              "June",
              "July",
              "August",
              "September",
              "October",
              "November",
              "December"
            ]}
          />
        </Box>
        <Box sx={{ mt: "40px" }}>
          <SubmitButton
            variant={"filled"}
            title="Show"
            fontWeight={"700"}
            handleSubmit={finalSummaryShowClickHandler}
            type="click"
          />
        </Box>
      </Box>
      <Box>
        <Typography
          sx={{
            fontSize: "20px",
            lineHeight: "24px",
            fontWeight: "400",
            color: "#000",
            mt: "32px",
            mb: "24px"
          }}
        >
          Final Choices Summary
        </Typography>
        <Box sx={{ mb: "40px" }}>
          <FinalChoicesSummery
            data={finalSummaryData !== undefined && finalSummaryData}
          />
        </Box>
        <Box>
          <Box
            sx={{
              mb: "26px"
            }}
          >
            <LeadersSearchHeader
              handleApply={applyFilters}
              search
              LeadFilterFunction={LeadFilterFunction}
              handleFilterResetData={handleFilterResetData}
              visibility={visibility}
              columnVisibleHandler={toggleNameColumn}
              searchHandleChange={searchHandleChange}
              handleSearchChange={handleSearchChange}
              component="reports"
            />
          </Box>
          <FinalChoicesList
            rows={reportData}
            columns={columns}
            showStudentNameColumn={showStudentNameColumn}
            showStudentIdColumn={showStudentIdColumn}
            showStudentUniversityColumn={showStudentUniversityColumn}
            showStudentCourseColumn={showStudentCourseColumn}
            showStartDateColumn={showStartDateColumn}
            showTutionFeeColumn={showTutionFeeColumn}
            showInvoiceColumn={showInvoiceColumn}
            showPaidToGslColumn={showPaidToGslColumn}
            showPaidToPartnerColumn={showPaidToPartnerColumn}
            showPaymentDateColumn={showPaymentDateColumn}
          />
          <Pagination
            sx={{
              mt: "28px",
              "& .Mui-selected": {
                backgroundColor: "#f81b82 !important",
                color: "#fff"
              },
              "& .MuiPagination-ul": {
                justifyContent: "end"
              }
            }}
            rowsPerPageOptions={[10, 25, 50, 100]} // Customize the rows per page options as needed
            component="div"
            // count={applicationAllFindSuccess?.totalPages}
            count={dataCount}
            rowsPerPage={applicationAllFindSuccess?.currentPage}
              // rowsPerPage={
              //   searchPagination ? searchPaginationRows :
              //     filterPagination ? allLeadApplicationFilterSuccess?.currentPage :
              //       applicationAllFindSuccess?.currentPage
              // }
            page={page}
            onChange={handleChangePage}
          // onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default ReportsTab;
